function ez_homeSlider() {
    var slider = $('._js-home-slider');

    if ( slider.length ) {

        slider.on('init afterChange', function(){
            const $this    = $(this);
            const header   = $('._js-website-header');
            const current  = $this.find('.slick-active');
            const type     = current.attr('data-type');
            const lightCls = '_light';
            const darkCls  = '_dark';

            if ( type === 'light' ) {
                $this.removeClass(darkCls).addClass(lightCls);
                header.removeClass(darkCls).addClass(lightCls);
            }
            else if ( type === 'dark' ) {
                $this.removeClass(lightCls).addClass(darkCls);
                header.removeClass(lightCls).addClass(darkCls);
            }
        });

        slider.slick({
            slide: '.ez_home-slider__element',
            rows: 0,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: true,
            lazyLoad: 'ondemand',
            adaptiveHeight: true,
            responsive : [
                {
                    breakpoint: 1199,
                    settings : {
                        arrows: false
                    }
                }
             ],
            customPaging:function (a, b) {
                return '<div class="wrapper" data-anim="base wrapper"><div class="circle" data-anim="base left"></div><div class="circle" data-anim="base right"></div></div>'
            }
        });
    }
}